<template>
  <div class="asset-list-container">
    <div class="asset-list">
      <asset-item
        v-for="(asset, index) in assets"
        :key="index"
        :asset="asset"
        @trigger-asset-modal="triggerAssetAction(asset)"
      />
    </div>
    <asset-association-modal
      v-if="currentAssetAssociation"
      :asset-association="currentAssetAssociation"
      @close-button-clicked="closeModal"
    />
  </div>
</template>

<script>
import AssetItem from './AssetItem.vue';
import AssetAssociationModal from '@components/assetAssociations/modal';

export default {
  name: 'AssetList',
  components: {
    AssetAssociationModal,
    AssetItem,
  },
  props: {
    assets: {
      type: Array,
      default: () => [],
    },
    assetAssociations: {
      type: Array,
      default: () => [],
    },
  },
  emits: ['flashcard-aa-clicked'],
  data() {
    return {
      currentAssetAssociation: undefined,
    };
  },
  methods: {
    closeModal() {
      this.currentAssetAssociation = undefined;
    },
    triggerAssetAction(asset) {
      const assetAssociation = this.assetAssociations.find(aa => aa.assetBId === asset.id);
      this.triggerAssetAssociationAction(assetAssociation);
    },
    triggerAssetAssociationAction(assetAssociation) {
      this[`trigger${assetAssociation.assetBType}Action`](assetAssociation);
    },
    triggerAttachmentAction(assetAssociation) {
      this.currentAssetAssociation = assetAssociation;
    },
    triggerGroupingAction(assetAssociation) {
      this.currentAssetAssociation = assetAssociation;
    },
    triggerTopicAction(assetAssociation) {
      this.currentAssetAssociation = assetAssociation;
    },
    triggerV3FlashcardAction(assetAssociation) {
      this.$emit('flashcard-aa-clicked', assetAssociation.id);
    },
  },
};
</script>

<style scoped lang="scss">
.asset-list-container {
  max-width: unset;
}
</style>
